<template>
  <PartnersGrid :partners="partners">
  </PartnersGrid>
</template>

<script setup>
import PartnersGrid from "../PartnersGrid.vue";
import PartnersCard from "../PartnersCard.vue";


defineProps({
  partners: {
    type: Array,
    default: () => [],
  },
});

const MediumPartners = [

   {
     src: "/assets/partners/exec.png",
     name: "Exec",
     href: "https://exec.shopsys.cz/",
   }
    ];

//   {
//     src: "/assets/partners/bridge.svg",
//     name: "Ecommerce Bridge",
//     href: "https://www.ecommercebridge.cz/",
//   },
//
//   {
//     src: "/assets/partners/marketaci-online.svg",
//     name: "Markeťáci online",
//     href: "https://marketaci.online/",
//   },
//   {
//     src: "/assets/partners/mladypodnikatel.svg",
//     name: "Mladý podnikatel",
//     href: "https://mladypodnikatel.cz/",
//   }

</script>

<style>
</style>
